import React, { useEffect, useState } from "react";
import Webcontainer from "../WebContainer/Index";
import Title from "../Title/Index";
import BreadCrumb from "../BreadCrumb/Index";
import MediaNavabar from "../Header/MediaNavabar";
import Gallery from "../Gallery/Index";
import axios from "axios";
import { API_BASE_URL } from "../../Utils/useApi";
import { CircularProgress } from "@mui/material";

const Events = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/media_gallery.php?cat=media`
        );
        setData(response.data);
        console.log("this is the respose", response.data);
      } catch (err) {
        setError(err.message || "An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchHomeData();
  }, []);

  if (loading)
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  if (error) return <div>Error: {error}</div>;
  const uniqueMonths = [
    ...new Set(
      data.map((item) => {
        const date = new Date(item.datemonth);
        return date.toLocaleString("default", { month: "short" }).toUpperCase();
      })
    ),
  ];

  const uniqueYears = [
    ...new Set(
      data.map((item) => {
        const date = new Date(item.datemonth);
        return date.getFullYear().toString();
      })
    ),
  ];

  return (
    <>
      <BreadCrumb
        customBreadCrum={true}  
        firstName={"media"}
        pageLink={"/media"}
        secondName={"Events"}
        _parentClass={"customBreadcrum"}
      />
      <Webcontainer _parentClass={"p-100"}>
        <Title secondHeading={"Events Gallery"} firstHeading={"Media & News"} />
        <div className="row">
          <MediaNavabar />
          <Gallery
            gallery_data={data}
            uniqueMonths={uniqueMonths}
            uniqueYears={uniqueYears}
            eventGallery={true}
          />
        </div>
      </Webcontainer>
    </>
  );
};

export default Events;
